<template>
    <IPViews v-if="!getCurrentFormView"/>
    <IPForm v-else/>
</template>

<script>

import {useIndividualPacking} from "@/hooks/useIndividualPacking";
import IPViews from "@/components/individual-packing/IPViews.vue";
import IPForm from "@/components/individual-packing/IPForm.vue";

export default {
    name: "IPMain",
    mixins: [useIndividualPacking],
    components: {
        IPForm,
        IPViews,
    },
}
</script>

<style scoped>

</style>